import {Component, computed, EventEmitter, Input, OnChanges, OnDestroy, Output, signal} from '@angular/core';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {animate, style, transition, trigger} from '@angular/animations';
import {TranslateModule} from '@ngx-translate/core';
import {AnimatedPrimusLogoComponent} from './animated-primus-logo/animated-primus-logo.component';
import {MatButton} from '@angular/material/button';

const animationTime = 300;
const messageLingerTime = 5000;

@Component({
    selector: 'app-splash-screen',
    imports: [
        MatProgressSpinner,
        MatButton,
        TranslateModule,
        AnimatedPrimusLogoComponent
    ],
    templateUrl: './splash-screen.component.html',
    styleUrl: './splash-screen.component.scss',
    animations: [
        trigger('fadeInOut', [
            transition('void => *', [style({ opacity: '0' }), animate(animationTime)]),
            transition('* => void', [animate(animationTime, style({ opacity: '0' }))]),
            transition('* => *', [
                style({ opacity: '0' }),
                animate(animationTime, style({ opacity: '1' })),
            ]),
        ])
    ]
})
export class SplashScreenComponent implements OnChanges, OnDestroy {
  @Input() currentSteps: string[] = [];
  @Input() infoMessageKey: string | null = null;
  @Input() actionLabelKey: string | null = null;
  @Output() action = new EventEmitter<void>();
  // workaround for making the @Input reactive. Set in ngOnChanges.
  currentStepsSignal = signal<string[]>([])

  loopTimer: any | null = null
  currentStepIndex = signal(0)
  currentStep = computed(() => this.currentStepsSignal()[this.currentStepIndex()])

  ngOnChanges(): void {
    this.currentStepsSignal.set(this.currentSteps ?? [])
    clearTimeout(this.loopTimer);
    this.currentStepIndex.set(0);
    this.loopTimer = setTimeout(() => this.incrementStepIndex(), messageLingerTime)
  }

  ngOnDestroy(): void {
    clearTimeout(this.loopTimer);
  }

  onActionClick() {
    this.action.emit();
  }

  private incrementStepIndex() {
    let newIndex = this.currentStepIndex() + 1
    if (newIndex >= this.currentSteps?.length) {
      // last message, stay here forever
      return
    }

    this.currentStepIndex.set(newIndex)
    this.loopTimer = setTimeout(() => this.incrementStepIndex(), messageLingerTime)
  }
}
